import { render } from "./legoListExtend.vue?vue&type=template&id=a998bae0&scoped=true"
import script from "./legoListExtend.vue?vue&type=script&lang=js"
export * from "./legoListExtend.vue?vue&type=script&lang=js"

import "./legoListExtend.vue?vue&type=style&index=0&id=a998bae0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a998bae0"],['__file',"src/components/lego/extend/legoListExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a998bae0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a998bae0', __exports__)) {
    api.reload('a998bae0', __exports__)
  }
  
  module.hot.accept("./legoListExtend.vue?vue&type=template&id=a998bae0&scoped=true", () => {
    api.rerender('a998bae0', render)
  })

}


export default __exports__